export enum RouteShipmentTypes {
    Nonacceptance = "Nonacceptance",
    Return = "Return",
    ReverseLogistics = "ReverseLogistics",
    Inbound = "Inbound",
    Outbound = "Outbound",
    Delegate = "Delegate",
    None = "None"
}